import { render, staticRenderFns } from "./ModalTagsEdit.vue?vue&type=template&id=4afd9616&scoped=true"
import script from "./ModalTagsEdit.vue?vue&type=script&lang=js"
export * from "./ModalTagsEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalTagsEdit.vue?vue&type=style&index=0&id=4afd9616&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd9616",
  null
  
)

export default component.exports